import React from "react";
import styles from "./header.module.css";
import Badge from "common/Badge";
import Button from "common/Button";
import { formatDateFromDateAndTime } from "utils";

const EventDetailsHeader = ({Badges=[],data, Functionalities=[]}) => {

  return (
    <>

        <div className={styles.header}>
          <div className={styles.eventDetails}>
            <img className={styles.eventImage} src={data?.event_image}/>
            <div className={styles.eventInfo}>
              <div className={styles.eventName}>{data?.event_name}</div>
              <div className={styles.eventTimeAndAddress}>
                {data?.starts&&<div className={styles.eventTime}> {formatDateFromDateAndTime(data?.starts)} - {formatDateFromDateAndTime(data?.ends)}</div>}
                <div className={styles.eventAddress}>{data?.venue}</div>
              </div>
              <div className={styles.eventBadge}>
                {
                  [data?.status]?.map((e) => <Badge label={e} />)
                }
              </div>
            </div>
          </div>
          <div className={styles.eventFunctionality}>
            {
              Functionalities?.map((e) => {
                return <Button buttonOverrideStyle={styles.eventHeadButton} label={e?.label} onClick={e?.onClick}></Button>
              })
            }
          </div>


      </div>
    </>
  );
};

export default EventDetailsHeader;
